// extracted by mini-css-extract-plugin
export default {"cell":"systemHistoryTable_cell__BEGWm"};